<div class="main-content">
  <div class="container-fluid p-0">
    <div class="row">
      <div class="col-md-12">
        <span class="pull-left py-3">
          <h2 class="text-purple-manax m-0 pl-3 title-section">Logger</h2>
          <p class="text-purple-manax pl-3 subtitle-section">Registro de actividad en el sistema</p>
        </span>
        <table class="table table-hover m-0 align-top" matSort (matSortChange)="sortLogger($event)" stickyHeader
          stickyFooter>

          <thead class="text-manax">
            <tr>

              <!-- All -->
              <th class="p-0 pl-2">
                <div class="form-check m-0 mx-2">
                  <label class="form-check-label">
                    <input class="form-check-input input-sm" type="checkbox">
                    <span class="form-check-sign">
                      <span class="check"></span>
                    </span>
                  </label>
                </div>
              </th>

              <!-- PC -->
              <th class="align-top" [ngClass]="{'d-table-cell': isGreaterThan672px(), 'd-none': !isGreaterThan672px()}"
                style="height: 65px; position: relative; max-width: 1000px;"> 
                Acción<br>
                <select [(ngModel)]="filter.filters.action" (ngModelChange)="getlogger(true)"
                  (click)="$event.stopPropagation()" class="filter small" style="max-width: 200px;">
                  <option [ngValue]="undefined"> Todos </option>
                  <option [ngValue]="action" *ngFor="let action of actionLabelsKeys">{{actionLabels[action]}}</option>
                </select>
              </th>

              <!-- PC -->
              <th class="align-top"mat-sort-header="company" style="height: 70px; position: relative;">
                Empresa<br>
                <input type="text" class="filter small" [(ngModel)]="filter.filters.company"
                  (ngModelChange)="lazySearch()" (click)="$event.stopPropagation()"
                  (keydown.space)="$event.stopPropagation()"
                  style="max-width: 1000px; position: absolute; top: 27px; left: 0px;" />
              </th>

              <!-- PC -->
              <th class="align-top" mat-sort-header="user" style="height: 70px; position: relative;">
                Usuario<br>
                <input type="text" class="filter small" [(ngModel)]="filter.filters.user"
                (ngModelChange)="lazySearch()" (click)="$event.stopPropagation()"
                (keydown.space)="$event.stopPropagation()"
                style="max-width: 1000px; position: absolute; top: 27px; left: 0px;" />
              </th>

              <th class="align-top" [ngClass]="{'d-table-cell': isGreaterThan672px(), 'd-none': !isGreaterThan672px()}"
                style="height: 65px; position: relative; max-width: 1000px;">
                Roles<br>
                <select [(ngModel)]="filter.filters.roles" (ngModelChange)="getlogger(true)"
                  (click)="$event.stopPropagation()" class="filter small" style="max-width: 200px;">
                  <option [ngValue]="undefined"> Todos </option>
                  <option [ngValue]="role" *ngFor="let role of roleLabelsKeys">{{roleLabels[role]}}</option>
                </select>
              </th>

              <!-- PC -->
              <th class="align-top" mat-sort-header="createdAt" style="height: 70px; position: relative;">
                Fecha
              </th>

              <!-- PC -->
              <th class="align-top" mat-sort-header="changes" style="height: 70px; position: relative;">
                Cambios
              </th>

              <!-- Mobile -->
              <th class="d-table-cell d-md-none">
                <span class="text-manax pull-right cursor-pointer" *ngIf="filtered"> - Filtrada - </span>
              </th>

              <!-- All -->
              <th class="td-actions text-right p-0">
                <button mat-icon-button type="button" class="btn btn-default btn-link btn-just-icon"
                  [matMenuTriggerFor]="menu" (click)="$event.stopPropagation()">
                  <i class="material-icons">more_vert</i>
                </button>
                <mat-menu #menu="matMenu">

                  <!-- sort order -->
                  <button mat-menu-item class="d-block d-md-none">
                    <span>Orden</span>
                  </button>

                  <!-- filters -->
                  <!--button mat-menu-item class="d-block d-md-none" (click)="openFilter()">
                          <span>Filtros</span>
                        </button-->
                  <button mat-menu-item (click)="clearFilter()">
                    <span>Limpiar Filtros</span>
                  </button>
                </mat-menu>

              </th>
            </tr>
          </thead>

          <tbody>
            <tr *ngFor="let log of logs" [class.text-danger]="log.isDeleted" class='cursor-pointer'
              (click)="openChangeLogModal(log)">

              <!-- All -->
              <td class="p-0 pl-2" (click)="$event.stopPropagation();">
                <div class="form-check m-0 mx-2">
                  <label class="form-check-label">
                    <input class="form-check-input input-sm" type="checkbox">
                    <span class="form-check-sign">
                      <span class="check"></span>
                    </span>
                  </label>
                </div>
              </td>

              <!-- PC -->
              <td class="d-none d-md-table-cell">{{log.action}}</td>
              <td class="d-none d-md-table-cell">{{log.company.name}}</td>
              <td class="d-none d-md-table-cell">{{log.user.username}}</td>
              <td class="d-none d-md-table-cell">
                <span *ngFor="let role of log.user.roles">{{roleLabels[role.name]}}<br></span>
              </td>
              <td class="d-none d-md-table-cell">{{log.createdAt | date:'dd/MM/yyyy HH:mm'}}</td>
              <td class="d-none d-md-table-cell">{{log.changes?.length > 0 ? 'Si' : 'No'}}</td>

              <!-- Mobile -->
              <td class="d-table-cell d-md-none" style="line-height: 14px;">
                <b>{{log.action}}</b><b>{{log.company.name}}</b><b>{{log.user.username}}</b><span
                  class="small pull-left">
                  <span *ngIf="log.user.roles?.length">
                    roles: <span *ngFor="let role of log.user.roles"> {{role.name}}. </span>
                  </span>
                </span><br><b>{{log.createdAt |
                  date:'dd/MM/yyyy HH:mm'}}</b>
              </td>

              <!-- All -->
              <td class="td-actions text-right p-0">
                <button mat-icon-button type="button" class="btn btn-default btn-link btn-just-icon"
                  [matMenuTriggerFor]="menu" (click)="$event.stopPropagation()">
                  <i class="material-icons">more_vert</i>
                </button>
                <mat-menu #menu="matMenu">
                </mat-menu>
              </td>
            </tr>

            <!-- All -->
            <tr *ngIf="thereAreMore && !loading">
              <td colspan="10">
                <button class="btn btn-link text-purple-manax text-capitalize p-0" (click)='loadMore()'>+ cargar
                  mas</button>
              </td>
            </tr>
            <tr *ngIf="loading">
              <td colspan="10" class="text-center">
                <div class="d-flex justify-content-center">
                  <div class="spinner-border" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
          <tfoot class="text-purple-manax">
            <tr *ngIf="!loading">
              <td colspan="10" class="text-left p-0 py-2 pl-3">Mostrando: {{ logs.length }} logs</td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  </div>
</div>